import { useApolloClient } from '@apollo/client'
import React from 'react'
import ReactSelectAsync from 'react-select/async'
import type { SelectAsyncProps} from './index';
import { setupLoadOptions, setupOptionLabel } from './index'
import { useReactSelect } from './useReactSelect'
import { useDebouncedLoadOptions } from './useDebouncedLoadOptions'
export const SelectAsync = ({
  getOptionLabel,
  labelKey = 'label',
  loadOptions,
  dataLoadOptions,
  defaultOptions = true,
  ...props
}: SelectAsyncProps) => {
  const client = useApolloClient()

  if (!getOptionLabel) {
    getOptionLabel = setupOptionLabel(labelKey)
  }

  if (!loadOptions) {
    loadOptions = setupLoadOptions({ client, dataLoadOptions, getOptionLabel })
  }

  const debouncedLoadOptions = useDebouncedLoadOptions(loadOptions)
  const properties = useReactSelect(props)

  return (
    <ReactSelectAsync {...properties} loadOptions={debouncedLoadOptions} getOptionLabel={getOptionLabel} defaultOptions={defaultOptions} cacheOptions={true} />
  )
}
